import React, { Fragment, useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import CustomerProducts from '../../Components/Order/CustomerProducts';
import TextInputWithButton from '../../Components/TextInputWithButton'
import Loader from '../../Components/Loader'
import DateTimeInput from "../../Components/FormComponents/Input/DateTimeInput"
import commonActions from '../../Actions/commonActions'
import customerActions from '../../Actions/customerActions'
import helpers from '../../Utils/helpers'
import customerRoutes from "../../Constants/Customer/customerRoutes";
import { CardContainer, CardRow, DefaultCard } from "../../Components/Card/Card";
import { FormInput } from "../../Components/FormComponents/Input/Input";
import { Dropdown } from "../../Components/FormComponents/Dropdown";

function ConsultingContainer({ customerActions, consultingProducts, commonActions, consultingForm, customer, user, productsLoading, subscriptions, products }) {

    const navigate = useNavigate();
    const { t } =useTranslation();
    const vbCustomer = customer.vbCustomer;
    
    useEffect(() => {
        customerActions.createConsultingForm(createConsultingFormData());
        if (!consultingProducts)
            commonActions.loadDropdownList("ConsultingProducts")
            }, [])

    useEffect(() => {
        if (customer.vbCustomer) 
            customerActions.getCustomerVBProducts(vbCustomer.customerNumber);
        
        if (customer.vossCustomer) 
            customerActions.searchSubscriptions(customer.vossCustomer.id);
        
    }, [])

    const handleClickCancel = () => {
        commonActions.cancelFormEditing(consultingForm.id, routeBack());
    }

    const routeBack = () => {
        return () => navigate(customerRoutes.customer(customer.pathId))
    }

    const handleClickSave = () => {
        customerActions.saveConsulting(consultingForm, vbCustomer.customerNumber, routeBack());
    }

    const addContactPerson = (customer) => {
        onFieldChange('reference', customer.contactPerson?.fullName)
        onFieldChange('attendeeEmail', customer.contactPerson?.email)

    }

    const onFieldChange = (field, value) => {
        commonActions.changeMultiFormField(consultingForm.id, field, value)
    }

    const onPriceChange = (value) => {
        let total = parseFloat(value) || 0
        commonActions.changeMultiFormField(consultingForm.id, "price", value)

        if (consultingForm.data.product.priceType === priceTypes.HourlyPrice ||
            consultingForm.data.product.priceType === priceTypes.OnboardingHourly)
            total = parseFloat(value * consultingForm.data.hoursCharged) || 0

        if (consultingForm.data.product.priceType === priceTypes.OnboardingTravel ||
            consultingForm.data.product.priceType === priceTypes.OnboardingTravelVariable)
            total += parseFloat(consultingForm.data.travelCost) || 0


        commonActions.changeMultiFormField(consultingForm.id, "totalCost", total)
    }

    const onTravelCostChange = (value) => {
        const price = parseFloat(consultingForm.data.price) || 0
        let total = (parseFloat(value) || 0) + price
        commonActions.changeMultiFormField(consultingForm.id, "travelCost", value)
        commonActions.changeMultiFormField(consultingForm.id, "totalCost", total)
    }

    const onHoursFieldChange = (value) => {
        const formData = consultingForm.data

        if (value) {
            customerActions.getConsultingTotalCost(consultingForm.data.product.id, value, formData.price)
        }

        commonActions.changeMultiFormField(consultingForm.id, "hoursCharged", value)
    }

    const createConsultingFormData = () => {
        return {
            salesforceTicketId: "",
            hoursCharged: "",
            totalCost: "",
            reference: "",
            price: 0,
            productId: 0,
            travelCost: 0,
            salesNumber: user.salesNumber,
            attendeeEmail: "",
            discount: null
        }
    }

    const onProductSelect = (id) => {
        commonActions.changeMultiFormField(consultingForm.id, "productId", id)
        commonActions.changeMultiFormField(consultingForm.id, "hoursCharged", 0)
        commonActions.changeMultiFormField(consultingForm.id, "price", 0)
        commonActions.changeMultiFormField(consultingForm.id, "travelCost", 0)
        if (id > 0)
            customerActions.getConsultingProduct(id)
    }

    const setOnlineBooking = (field, value) => {
        commonActions.changeMultiFormField(consultingForm.id, field, value)
    }

    const renderInputControls = () => {
        const formData = consultingForm.data
        if (!formData || !formData.product)
            return null;
        const product = formData.product

        let salesforceTicket = null;
        if (product.requireSalesforceTicket)
            salesforceTicket = <FormInput label="Salesforce Ticket Id *" value={formData.salesforceTicketId}
                onChange={(value) => onFieldChange("salesforceTicketId", value)} />

        let salesNumber = null;

        const salesNumberInputProps = {
            buttonTitle: t('consultingcontainer.onlinebooking'),
            label: t('consultingcontainer.salesnumber'),
            value: formData.salesNumber,
            onChange: (value) => onFieldChange('salesNumber', value),
            buttonClick: () => setOnlineBooking('salesNumber', 242)
        }

        let certificateInfo = null;

        if (product.sendCertificate) {
            certificateInfo =
                <Fragment>
                    <FormInput label={t('consultingcontainer.lengthinhours')} value={formData.lengthInHours} onChange={(value) => onFieldChange("lengthInHours", value)} />
                    <FormInput label={t('consultingcontainer.coursecoordinator')} value={formData.courseCoordinator} onChange={(value) => onFieldChange("courseCoordinator", value)} />
                    <DateTimeInput label={t('consultingcontainer.coursedate')} dateFormat={true} showTime={false} value={formData.courseDate} onChange={(value) => onFieldChange("courseDate", value)} />
                </Fragment>
        }

        if (product.priceType >= priceTypes.OnboardingFixed)
            salesNumber =
                <div >
                    <TextInputWithButton {...salesNumberInputProps} />
                </div>

        switch (product.priceType) {
            case priceTypes.FixedPrice:
                return <div style={{ marginBottom: '6px' }}>
                    {salesforceTicket}
                    <FormInput label={t('consultingcontainer.price')} value={formData.totalCost}
                        onChange={onPriceChange} />
                    {certificateInfo}
                </div>

            case priceTypes.VariablePrice:
                return <div style={{ marginBottom: '6px' }}>
                    {salesforceTicket}
                    <FormInput label={t('consultingcontainer.price')} value={formData.totalCost}
                        onChange={onPriceChange} />
                    {certificateInfo}
                </div>

            case priceTypes.HourlyPrice:
                return <div style={{ marginBottom: '6px' }}>
                    {salesforceTicket}
                    <FormInput label={t('consultingcontainer.hours')} value={formData.hoursCharged}
                        onChange={onHoursFieldChange} />
                    <FormInput label={t('consultingcontainer.hourlyprice')} value={formData.price}
                        onChange={onPriceChange} />
                    {certificateInfo}
                </div>
            case priceTypes.OnboardingHourly:
                return <div style={{ marginBottom: '6px' }}>
                    {salesforceTicket}
                    <FormInput label={t('consultingcontainer.hours')} value={formData.hoursCharged}
                        onChange={onHoursFieldChange} />
                    <FormInput label={t('consultingcontainer.hourlyprice')} value={formData.price}
                        onChange={onPriceChange} />
                    {certificateInfo}
                    {salesNumber}
                </div>
            case priceTypes.OnboardingTravel:
                return <div style={{ marginBottom: '6px' }}>
                    {salesforceTicket}
                    <FormInput label={t('consultingcontainer.price')} value={formData.price}
                        onChange={onPriceChange} />
                    <FormInput label={t('consultingcontainer.travelcost')} value={formData.travelCost}
                        onChange={onTravelCostChange} />
                    {certificateInfo}
                    {salesNumber}
                </div>

            case priceTypes.OnboardingTravelVariable:
                return <div style={{ marginBottom: '6px' }}>
                    {salesforceTicket}
                    <FormInput label={t('consultingcontainer.price')} value={formData.price}
                        onChange={onPriceChange} />
                    <FormInput label={t('consultingcontainer.travelcost')} value={formData.travelCost}
                        onChange={onTravelCostChange} />
                    {certificateInfo}
                    {salesNumber}
                </div>

            case priceTypes.OnboardingFixed:
                return <div style={{ marginBottom: '6px' }}>
                    {salesforceTicket}
                    <FormInput label={t('consultingcontainer.price')} value={formData.totalCost}
                        onChange={onPriceChange} />
                    {certificateInfo}
                    {salesNumber}
                </div>
            default:
                return null
        }
    }

    const calculateTotalCost = (formData) => {
        return formData.totalCost - (formData.totalCost * (formData.discount / 100))
    }

    if (!consultingForm || !vbCustomer) {
        return null;
    }


    const formData = consultingForm.data

    const textInputProps = {
        buttonTitle: t('consultingcontainer.usecontactsinfo'),
        label: t('consultingcontainer.attendeename'),
        value: formData.reference,
        onChange: (value) => onFieldChange('reference', value),
        buttonClick: () => addContactPerson(vbCustomer)
    }

    var totalCost = calculateTotalCost(formData)

    return <CardContainer >
        <CardRow orientation={"horizontal"}>
            <DefaultCard title={t('consultingcontainer.header')}>
                <fieldset className="d-grid col gap-24 mb-0 pl-0">
                    <Dropdown label={t('consultingcontainer.product')} onChange={onProductSelect} options={consultingProducts} value={formData.product?.id} />
                    {renderInputControls()}
                    <FormInput label={t('consultingcontainer.totalcost')} value={helpers.currencyFormatter(totalCost)} disabled={true} onChange={(value) => onFieldChange("totalCost", value)} />
                    {formData.discount && <FormInput label={t('consultingcontainer.discountpercentage')} value={formData.discount} disabled={true} onChange={(value) => onFieldChange("discount", value)} />}
                    <TextInputWithButton {...textInputProps} />
                    <FormInput label={t('consultingcontainer.attendeeemail')} value={formData.attendeeEmail} onChange={(value) => onFieldChange("attendeeEmail", value)} />
                    <div className="form-group padding-top no-left-margin btn-toolbar">
                        <button type="button" className="btn btn-primary" onClick={handleClickSave}>{t('consultingcontainer.save')}</button>
                        <button type="button" className="btn btn-default" onClick={handleClickCancel}>{t('consultingcontainer.cancel')}</button>
                        <Loader />
                    </div>
                </fieldset>
            </DefaultCard>
            <DefaultCard title={t('customerproducts.products')} isLoading={productsLoading}>
                <CustomerProducts subscriptions={subscriptions} products={products} />
            </DefaultCard>
        </CardRow>
    </CardContainer>
}


const priceTypes = {
    FixedPrice: 1,
    VariablePrice: 2,
    HourlyPrice: 3,
    OnboardingFixed: 4,
    OnboardingHourly: 5,
    OnboardingTravel: 6,
    OnboardingTravelVariable: 7
}

function mapStateToProps(state) {
    return {
        user: state.CommonReducer.user,
        customer: state.CustomerReducer.customer,
        subscriptions: state.CustomerReducer.subscriptions,
        vbProducts: state.CustomerReducer.vbProducts,
        consultingForm: state.CommonReducer.forms && state.CommonReducer.forms.consulting,
        consultingProducts: state.CommonReducer.dropdownlists?.ConsultingProducts,
        productsLoading: state.CommonReducer.dataLoading.vbProducts || state.CommonReducer.dataLoading.vonProducts || state.CommonReducer.dataLoading.subscriptions,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        commonActions: bindActionCreators(commonActions, dispatch),
        customerActions: bindActionCreators(customerActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConsultingContainer);